(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/draw-widgets/assets/javascripts/widget-public-container.js') >= 0) return;  svs.modules.push('/components/pool-betting/draw-widgets/assets/javascripts/widget-public-container.js');
"use strict";

const {
  WidgetArea
} = svs.components.lbUtils.widgetArea;
const {
  drawStateEnums,
  getDrawStateEnum
} = svs.components.sport.tipsenShared;
const {
  useDraw
} = svs.components.sport.drawsRedux.hooks;
const WidgetPublicContainer = _ref => {
  let {
    drawNumber,
    productId,
    className
  } = _ref;
  const draw = useDraw({
    productId,
    drawNumber
  });
  const drawState = getDrawStateEnum(draw === null || draw === void 0 ? void 0 : draw.drawStateId);
  const isLive = drawState === drawStateEnums.LIVE;
  const classNames = ['draw-widget-container'];
  className && classNames.push(className);
  if (isLive) {
    return React.createElement(WidgetArea, {
      className: classNames.join(' '),
      widgetArea: "drawLive"
    });
  }
  return React.createElement(WidgetArea, {
    className: classNames.join(' '),
    widgetArea: "drawNotLive"
  });
};
setGlobal('svs.components.poolBetting.drawWidgets.WidgetPublicContainer', WidgetPublicContainer);

 })(window);